module.exports = {"id":"209610","name":"José Juan Vázquez","rating":"76","photo":"./data/images/photos/1/209610.png","club":{"name":"Santos Laguna","logo":"./data/images/clubs/SantosLaguna.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseJuanVazquez0.json
// module id = 2171
// module chunks = 0